import { useState } from "react";
import API from "../services/api";

export default function Notifications() {
  const [studentId, setStudentId] = useState("");
  const [message, setMessage] = useState("");
  const [type, setType] = useState("Attendance");

  const handleSend = async () => {
    try {
      await API.post("/notifications/send", {
        student_id: studentId,
        message,
        type
      });

      alert("Notification sent successfully");

      setStudentId("");
      setMessage("");
      setType("Attendance");

    } catch (err) {
      alert("Notification failed");
    }
  };

  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-6">
        Parent Notifications
      </h1>

      <div className="bg-white shadow p-6 rounded">

        <input
          type="text"
          placeholder="Student ID"
          value={studentId}
          onChange={(e) => setStudentId(e.target.value)}
          className="border p-2 mb-3 w-full"
        />

        <select
          value={type}
          onChange={(e) => setType(e.target.value)}
          className="border p-2 mb-3 w-full"
        >
          <option>Attendance</option>
          <option>Fees</option>
          <option>General</option>
        </select>

        <textarea
          placeholder="Enter notification message"
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          className="border p-2 mb-3 w-full"
          rows="4"
        />

        <button
          onClick={handleSend}
          className="bg-green-600 text-white px-4 py-2 rounded"
        >
          Send Notification
        </button>

      </div>
    </div>
  );
}